import { render, staticRenderFns } from "./EtsyKategori.vue?vue&type=template&id=1ce0ccef&scoped=true"
import script from "./EtsyKategori.vue?vue&type=script&lang=js"
export * from "./EtsyKategori.vue?vue&type=script&lang=js"
import style0 from "./EtsyKategori.vue?vue&type=style&index=0&id=1ce0ccef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce0ccef",
  null
  
)

export default component.exports